<!--  -->
<template>
  <div class="data-container">
    <div class="data-content">
      <div class="data-top" v-if="currentTopColum">
        <a-table
          :dataSource="currentTopData"
          :columns="currentTopColum"
          bordered
          :scroll="{ x: 100, y: 300 }"
          :pagination="false"
        />
      </div>
      <div class="data-bottom">
        <div class="bottom-form">
          <a-form :model="formState">
            <a-form-item label="邮箱/手机">
              <a-input v-model:value="formState.user" allowClear placeholder="请输入查询的邮箱/手机号/第三方账号" />
            </a-form-item>
            <a-form-item label="查询时间">
              <a-range-picker
                v-model:value="formState.time"
                :show-time="{ format: 'HH:mm' }"
                style="width: 100%"
                format="YYYY-MM-DD HH:mm"
                allowClear
                :placeholder="['Start Time', 'End Time']"
              />
            </a-form-item>
            <template v-if="route.query.type === '2'">
              <a-form-item label="中奖状态">
                <a-select v-model:value="formState.lotteryStatus" style="width: 100%">
                  <a-select-option value="-1">全部</a-select-option>
                  <a-select-option value="0">未中奖</a-select-option>
                  <a-select-option value="1">已中奖</a-select-option>
                </a-select>
              </a-form-item>
            </template>
          </a-form>
        </div>
        <div class="bottom-btn">
          <a-button type="primary" class="btn" @click="initData('click')">查询</a-button>
          <a-button class="btn-right" @click="downLoadChange">下载数据</a-button>
        </div>
        <div class="bottom-number">
          <a-badge
            :count="total"
            :overflow-count="999"
            class="total-badge"
            :number-style="{ backgroundColor: '#1890ff' }"
          >
            <span class="total">总数量{{total === 0 ? 0 : ''}}</span>
          </a-badge>
          <a-badge
            :count="filterTotal"
            :overflow-count="999"
            class="last-badge"
            :number-style="{ backgroundColor: '#52c41a' }"
          >
            <span class="total">筛选后数量{{filterTotal !== 0 ? '' : 0}}</span>
          </a-badge>
        </div>
        <a-table
          :dataSource="currentBottomData"
          :columns="currentBottomColum"
          bordered
          :pagination="false"
          :loading="loading"
        />
        <div class="table-page">
          <a-pagination
            v-model:current="currentPageNumber"
            :total="filterTotal"
            show-less-items
            @change="paginationChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  computed,
  toRefs,
  onMounted,
  ref
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { getStatistics, statisticsDownload } from "@/api/index";
import { eventData } from "@/config/antd.js";
import { downLoadFile } from "@/utils/index";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import DayJs from "dayjs";

export default defineComponent({
  setup(props, content) {
    const route = useRoute();
    const store = useStore();
    const state = reactive({
      formState: {},
      currentPageNumber: 1,
      total: 0,
      loading: false,
      filterTotal: 0
    });
    const currentTopColum = computed(() => {
      const { query } = route;
      let currentItem;
      switch (query.type) {
        case "1":
          currentItem = eventData.topColumns1;
          break;
        case "3":
          currentItem = eventData.topColumns3;
          break;
      }
      return currentItem;
    });
    const currentBottomColum = computed(() => {
      const { query } = route;
      let currentItem;
      switch (query.type) {
        case "1":
          currentItem = eventData.bottomColumns1;
          break;
        case "4":
          currentItem = eventData.bottomColumns2;
          break;

        case "3":
          currentItem = eventData.bottomColumns3;
          break;
        case "2":
          currentItem = eventData.bottomColumns4;
          break;
      }
      return currentItem;
    });

    const currentTopData = ref([]);
    const currentBottomData = ref([]);
    const initData = async text => {
      // 处理搜索数据
      if (text) {
        state.currentPageNumber = 1;
      }
      state.loading = true;
      const params = {
        pageSize: 10,
        pageNumber: state.currentPageNumber
      };
      if (state.formState.user) {
        params.user = state.formState.user;
      }
      if (state.formState.time && state.formState.time.length > 0) {
        params.beginTime = moment(state.formState.time[0]).unix();
        params.endTime = moment(state.formState.time[1]).unix();
      }
      if (state.formState.lotteryStatus) {
        params.lotteryStatus = state.formState.lotteryStatus;
      }
      const res = await getStatistics(params, route.query.id);
      console.log(res, "resssss");
      const { list, statistics, total, filterTotal } = res.data;
      state.total = total;
      state.filterTotal = filterTotal;
      currentTopData.value = statistics;
      list.forEach(item => {
        item.createdAt = DayJs(item.createdAt * 1000).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        if (route.query.type === "4") {
          item.inviteTime = DayJs(item.inviteTime * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          );

          item.userTypeText =
            item.userType === 1
              ? "手机号"
              : item.userType === 2
              ? "邮箱"
              : "第三方fb";
          item.inviteUserTypeText =
            item.inviteUserType === 1
              ? "手机号"
              : item.inviteUserType === 2
              ? "邮箱"
              : "第三方fb";
        }
        //抽奖
        if (route.query.type == "2") {
          item.statusText = item.status === 0 ? "未中奖" : "已中奖";
        }
      });
      currentBottomData.value = list;
      state.loading = false;
    };
    let currentGameCodeRef = computed(
      () => store.state.settings.currentGamgeCode
    );
    const downLoadChange = async () => {
      let params = {};
      if (state.formState.user) {
        params.user = state.formState.user;
      }
      if (state.formState.time && state.formState.time.length > 0) {
        params.beginTime = moment(state.formState.time[0]).unix();
        params.endTime = moment(state.formState.time[1]).unix();
      }
      if (state.formState.lotteryStatus) {
        params.lotteryStatus = state.formState.lotteryStatus;
      }
      console.log(params, "000");
      const res = await statisticsDownload(params, route.query.id);
      console.log(res, "rrrr");
      const { query } = route;
      let name;
      switch (query.type) {
        case "1":
          name = "投票";
          break;
        case "2":
          name = "抽奖";
          break;
        case "3":
          name = "答题";
          break;
        case "4":
          name = "邀请好友";
          break;
      }
      downLoadFile(res.data, currentGameCodeRef.value, name);
    };
    const paginationChange = () => {
      initData();
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      locale,
      currentTopColum,
      currentBottomColum,
      currentTopData,
      currentBottomData,
      route,
      initData,
      downLoadChange,
      paginationChange
    };
  }
});
</script>
<style lang="less">
.bottom-form .ant-form {
  display: grid;
  grid-template-columns: 32% 32% 32%;
  grid-column-gap: 20px;
  .ant-form-item .ant-form-item-control-wrapper {
    width: 100%;
  }
}
.total-badge .ant-badge-count {
  right: -13px !important;
}
.last-badge .ant-badge-count {
  right: -13px !important;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
@import "./index.less";
.table-page {
  #flex-box.row-e();
  margin-top: 10px;
}
</style>